import React, { useState, useEffect } from 'react';
import { historyPropType } from '~/config/routerPropTypes';
import { showAppointmentCategories } from '~/config/routes';
import Request from '~/providers/Request';
import AppointmentCategoriesRecord from '~/records/AppointmentCategoriesRecord';
import Form from './Form';

function EditRecord({ history }) {
  const [record, setRecord] = useState(new AppointmentCategoriesRecord());
  const [loading, setLoading] = useState(false);
  const { id } = history.location.route.getParams();

  useEffect(() => {
    async function fetchData(id) {
      setLoading(true);
      Request.get(`/admin/appointment_categories/${id}`, {})
        .then((response) => {
          setLoading(false);
          setRecord(record.updateAttributes(response.data));
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    }
    fetchData(id);
  }, []);

  const handleChange = (attrs) => {
    setRecord(record.updateAttributes(attrs));
  };

  async function onSubmit() {
    const data = record.toParams();

    Request.put(`/admin/appointment_categories/${id}`, data, {}, { controller: 'appointmentCategories' })
      .then((resp) => {
        setLoading(false);
        history.push(showAppointmentCategories.reverse(resp.data));
      })
      .catch((e) => {
        console.error(e);
        setLoading(false);
      });
  }

  return (
    <Form
      onSubmit={onSubmit}
      record={record}
      handleChange={handleChange}
      loading={loading}
      setRecord={setRecord}
    />
  );
}

EditRecord.propTypes = {
  history: historyPropType,
};

export default EditRecord;
